import { DEFAULT_INSIGHT_TAB, INSIGHT_TABS } from '../config/insights-config'
import type { InsightTab } from '../config/insights-config'

export interface InsightsSearch {
  tab: InsightTab
}

/** Keeps the active tab in the URL so it survives reloads and shares. */
export function validateInsightsSearch(
  raw: Record<string, unknown>,
): InsightsSearch {
  const tab = raw['tab']
  const isValid =
    typeof tab === 'string' && (INSIGHT_TABS as readonly string[]).includes(tab)
  return { tab: isValid ? (tab as InsightTab) : DEFAULT_INSIGHT_TAB }
}
